import { WebBlock } from '../models';
import type { ThemePreset } from '../models';
import { renderBlocks } from './export/renderers';
import { buildEmbeddedScript } from './export/scripts';
import { buildBaseStyles } from './export/styles';
import { normalizeApiBase } from './export/helpers';

export interface BusinessMetadata {
    name?: string;
    address?: string;
    phone?: string;
    email?: string;
    hours?: string;
}

/**
 * Genera un string HTML válido representando los bloques actuales del Builder V2.
 */
export function exportWebConfigToHtml(
    blocks: WebBlock[],
    publicApiBaseUrl?: string,
    businessData?: BusinessMetadata,
    themePreset?: ThemePreset
): string {
    const blocksHtml = renderBlocks(blocks, publicApiBaseUrl, businessData);
    const apiBase = normalizeApiBase(publicApiBaseUrl);

    return `<!DOCTYPE html>
<html lang="es">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Web Exportada | Builder V2</title>
    <style>
${buildBaseStyles(themePreset)}
    </style>
</head>
<body>
    <main>
${blocksHtml}
    </main>
${buildEmbeddedScript(apiBase)}
</body>
</html>`;
}

export function downloadHtml(htmlContent: string, filename = 'index.html') {
    const blob = new Blob([htmlContent], { type: 'text/html;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}
